import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import '../styles/bootstrap.min.css';
import '../styles/style.css';
import MainSidebar from '../components/MainSidebar';
import rightarrow from '../assets/images/right.svg';
import config from '../config/config';

const Bankaccountdetails = () => {
  const [userData, setUserData] = useState({
    account_holder_name: '',
    account_number: '',
    account_code: '',
    account_type: '',
    user_name: '',
  });
  const [newAccountHolderName, setNewAccountHolderName] = useState('');
  const [newAccountNumber, setNewAccountNumber] = useState('');
  const [newAccountCode, setNewAccountCode] = useState('');
  const [newAccountType, setNewAccountType] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const [loading, setLoading] = useState(true);
  const [accountHolderNameError, setAccountHolderNameError] = useState('');
  const [accountNumberError, setAccountNumberError] = useState('');
  const [accountTypeError, setAccountTypeError] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) {
      navigate('/Login');
      return;
    }

    const fetchUserDetails = async () => {
      try {
        const response = await axios.get(`${config.baseURL}/current-user-details`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        const userDetails = response.data.data.user_details;
        const user = response.data.data.user;
        const accountDetails = response.data.data.account_details;

        // Set user details including bank account information
        setUserData({
          ...userDetails,
          user_name: user.user_name,
          account_holder_name: accountDetails.account_holder_name,
          account_number: accountDetails.account_number,
          account_code: accountDetails.account_code,
          account_type: accountDetails.account_type,
        });

        // Set individual fields for editing (if values exist)
        setNewAccountHolderName(accountDetails.account_holder_name || '');
        setNewAccountNumber(accountDetails.account_number || '');
        setNewAccountCode(accountDetails.account_code || '');
        setNewAccountType(accountDetails.account_type || '');

        setLoading(false);
      } catch (error) {
        console.error('Error fetching user details', error);
        setLoading(false);
      }
    };

    fetchUserDetails();
  }, [navigate]);

  // Validation Functions
  const validateAccountHolderName = (name) => {
    const nameRegex = /^[A-Za-z\s]+$/; // Only alphabets and spaces
    if (!name) {
      setAccountHolderNameError('Account Holder Name is required.');
    } else if (!nameRegex.test(name)) {
      setAccountHolderNameError('Account Holder Name must contain only alphabets.');
    } else if (name.length < 5 || name.length > 30) {
      setAccountHolderNameError('Account Holder Name must be between 25 and 30 characters.');
    } else {
      setAccountHolderNameError('');
    }
  };

  const validateAccountNumber = (number) => {
    const numberRegex = /^[0-9]+$/; // Only numbers
    if (!number) {
      setAccountNumberError('Account Number is required.');
    } else if (!numberRegex.test(number)) {
      setAccountNumberError('Account Number must contain only numbers.');
    } else {
      setAccountNumberError('');
    }
  };

  const validateAccountType = (type) => {
    if (!type) {
      setAccountTypeError('Account Type is required.');
    } else if (type.length < 5 || type.length > 30) {
      setAccountTypeError('Account Type must be between 25 and 30 characters.');
    } else {
      setAccountTypeError('');
    }
  };

  const handleAccountHolderNameChange = (e) => {
    const { value } = e.target;
    setNewAccountHolderName(value);
    validateAccountHolderName(value);
  };

  const handleAccountNumberChange = (e) => {
    const { value } = e.target;
    setNewAccountNumber(value);
    validateAccountNumber(value);
  };

  const handleAccountTypeChange = (e) => {
    const { value } = e.target;
    setNewAccountType(value);
    validateAccountType(value);
  };

  const handleAccountCodeChange = (e) => {
    setNewAccountCode(e.target.value);
  };

  const handleBackClick = () => {
    navigate(-1); // Go back to the previous page
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Run validations
    validateAccountHolderName(newAccountHolderName);
    validateAccountNumber(newAccountNumber);
    validateAccountType(newAccountType);

    if (accountHolderNameError || accountNumberError || accountTypeError) {
      return; // Don't submit if there are errors
    }

    const token = localStorage.getItem('token');
    try {
      const response = await axios.post(
        `${config.baseURL}/update-account-details`,
        {
          account_holder_name: newAccountHolderName,
          account_number: newAccountNumber,
          account_code: newAccountCode,
          account_type: newAccountType,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.data.success) {
        setSuccessMessage('Bank account details updated successfully');
        setErrorMessage('');
        setUserData({
          ...userData,
          account_holder_name: newAccountHolderName,
          account_number: newAccountNumber,
          account_code: newAccountCode,
          account_type: newAccountType,
        });
      } else {
        setErrorMessage(response.data.message);
        setSuccessMessage('');
      }
    } catch (error) {
      if (error.response && error.response.data && error.response.data.message) {
        setErrorMessage(error.response.data.message);
      } else {
        setErrorMessage('Error updating bank account details');
      }
      setSuccessMessage('');
      console.error('Error updating bank account details', error);
    }
  };

  return (
    <div>
      <div className="main_patreonpass_wrapper">
        <div className="patreonpass_container">
          <div className="left_sidebar">
            <MainSidebar />
          </div>
          <div className="patreonpass_main_content edit_profile_settings" id="content">
            <div className="left_main_content">
              <div className="feed_wrapper">
                <div className="page_title_with_dropdown notification_page">
                  <div className="page_heading">
                    <button className="profile_back_btn" onClick={handleBackClick}>
                      <svg
                        width={54}
                        height={54}
                        viewBox="0 0 54 54"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M48 27.5363L5.99998 27.5363M5.99998 27.5363L27 49.0532M5.99998 27.5363L27 6.3032"
                          stroke="#222"
                          strokeWidth={6}
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </button>
                    <h1>SETTINGS</h1>
                  </div>
                  
                </div>
                <div className="menus_all_wrapper">
                  <div className="edit_settings_menu_list">
                    <h3><a href={`/${userData.user_name}`}>@{userData.user_name}</a></h3>
                    <ul>
                      <li><Link to="/EditProfile">Profile <span className="menu_arrow"><img src={rightarrow} alt="" /></span></Link></li>
                      <li><Link className="active_profile_menu" to="/AccountSettings">Account <span className="menu_arrow"><img src={rightarrow} alt="" /></span></Link></li>
                      <li><Link to="/PrivacySafetySettings">Privacy and safety <span className="menu_arrow"><img src={rightarrow} alt="" /></span></Link></li>
                      <li><Link to="/NotificationSettings">Notifications <span className="menu_arrow"><img src={rightarrow} alt="" /></span></Link></li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div className="right_main_content">
              <form onSubmit={handleSubmit}>
                <div className="page_title_with_dropdown notification_page">
                  <div className="page_heading">
                    <h1>Bank Account Details</h1>
                  </div>
                </div>
                <div className="fields_menu_bottom_box_edit_account edit_username_fields">
                  <div className="editable_fields_user edit_username_field edit_bank_account">
                    <div className="row">
                      <div className="col-md-12">
                        <div className="mb-4 position_relative">
                          <input
                            type="text"
                            value={newAccountHolderName}
                            onChange={handleAccountHolderNameChange}
                            className="form-control"
                            id="account_holder_name"
                            required
                          />
                          <label htmlFor="account_holder_name" className="placeholder-label active_label">
                            Account Holder Name
                          </label>
                          {accountHolderNameError && <div className="text-danger">{accountHolderNameError}</div>}
                        </div>
                      </div>
                      <div className="col-md-12">
                        <div className="mb-4 position_relative">
                          <input
                            type="text"
                            value={newAccountNumber}
                            onChange={handleAccountNumberChange}
                            className="form-control"
                            id="account_number"
                            required
                          />
                          <label htmlFor="account_number" className="placeholder-label active_label">
                            Account Number
                          </label>
                          {accountNumberError && <div className="text-danger">{accountNumberError}</div>}
                        </div>
                      </div>
                      <div className="col-md-12">
                        <div className="mb-4 position_relative">
                          <input
                            type="text"
                            value={newAccountCode}
                            onChange={handleAccountCodeChange}
                            className="form-control"
                            id="account_code"
                            required
                          />
                          <label htmlFor="account_code" className="placeholder-label active_label">
                            Account Code
                          </label>
                        </div>
                      </div>
                      <div className="col-md-12">
                        <div className="mb-4 position_relative">
                          <select
                            value={newAccountType}
                            onChange={handleAccountTypeChange}
                            className="form-control"
                            id="account_type"
                            required
                          >
                            <option value="">Select Account Type</option>
                            <option value="Checking">Checking</option>
                            <option value="Savings">Savings</option>
                            <option value="Business">Business</option>
                          </select>
                          <label htmlFor="account_type" className="placeholder-label active_label">
                            Account Type
                          </label>
                          {accountTypeError && <div className="text-danger">{accountTypeError}</div>}
                        </div>
                      </div>
                    </div>
                    {errorMessage && (
                      <div className="row">
                        <div className="col-md-12 mb-4 text-danger">
                          {errorMessage}
                        </div>
                      </div>
                    )}
                    {successMessage && (
                      <div className="row">
                        <div className="col-md-12 mb-4 text-success">
                          {successMessage}
                        </div>
                      </div>
                    )}
                    <div className="divider_line" />
                    <div className="row">
                      <div className="col-md-12 text-right">
                        <button type="submit" className="g-btn m-rounded border-none m-border m-block">
                          Update Bank Account Details
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Bankaccountdetails;
